import React from "react";
import { Loader2, ShieldAlert } from "lucide-react";
import { AdminProvider, useAdmin } from "./AdminContext";
import Login from "./Login";
import Dashboard from "./Dashboard";
import { T } from "./theme";

function Gate() {
  const { user, ready, logout } = useAdmin();
  if (!ready || user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: T.bg }}>
        <Loader2 className="animate-spin" style={{ color: T.gold }} size={32} />
      </div>
    );
  }
  if (!user) return <Login />;

  // Super admins may not use the Client Portal — sign them out with a neutral message
  if (user.role === "super_admin") {
    return (
      <div className="min-h-screen flex items-center justify-center px-6" style={{ background: T.bg }}>
        <div className="max-w-md w-full p-8 rounded-2xl text-center"
          style={{ background: T.card, border: `1px solid ${T.border}`, boxShadow: T.shadow }}>
          <div className="w-14 h-14 mx-auto rounded-xl flex items-center justify-center mb-4"
            style={{ background: `${T.danger}22`, color: T.danger }}>
            <ShieldAlert size={26} />
          </div>
          <h2 className="font-display font-extrabold text-xl mb-2" style={{ color: T.text }}>
            This account is not authorized here
          </h2>
          <p className="text-sm mb-5" style={{ color: T.textDim }}>
            Please sign out and log in with a Top of the Line Tree Services LLC account.
          </p>
          <button onClick={logout}
            className="w-full rounded-lg py-2.5 font-semibold text-sm"
            style={{ background: `linear-gradient(135deg, ${T.gold}, ${T.goldHi})`, color: "#0A2415" }}>
            Sign out
          </button>
        </div>
      </div>
    );
  }

  return <Dashboard />;
}

export default function AdminApp() {
  return (
    <AdminProvider>
      <Gate />
    </AdminProvider>
  );
}
